export const WingmanIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 100 100"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Wingman Ventures AI"
    role="img"
  >
    <path d="M12 20 L50 88 L88 20" stroke="currentColor" strokeWidth="15" strokeLinejoin="miter" />
    <path d="M36 22 L64 22 L50 50 Z" fill="#4E5BC7" />
  </svg>
);
